import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    FormControl,
    TextField,
    Button,
    Paper,
    IconButton,
    Tooltip,
    Stack,
    useTheme,
    LinearProgress,
    Select,
    MenuItem,
    InputLabel,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import * as Yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {
    fetchApidata,
    explorePostData,
    postData,
    getFetchData,
    requestMail,
    PermissionApprovalVerify,
} from "../../store/reducers/Formapireducer";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import axios from "axios";

import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
    GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import FileListPopup from "../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../ui-components/FileUploadButton";
import { attachmentPost } from "../../store/reducers/LoginReducer";
import GradingIcon from '@mui/icons-material/Grading';
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../Theme";
import store from "../../index";
import { LoadingButton } from "@mui/lab";
import { fetchExplorelitview } from "../../store/reducers/Explorelitviewapireducer";
import Listviewpopup from "../pages/Lookup";
import Popup from "../pages/popup";
import { toast } from "react-hot-toast";
import { Productautocomplete, CheckinAutocomplete } from "../../ui-components/global/Autocomplete";
import { formGap } from "../../ui-components/global/utils";
import { leaveAppoval, mailNotify } from "../../store/reducers/Listviewapireducer";
import { fileUpload } from "../../store/reducers/Imguploadreducer";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CryptoJS from "crypto-js";


const KEY = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse("1234567890123456");
function decryptDataUrlSafe(urlSafeBase64) {
    // Convert back to standard base64
    let base64 = urlSafeBase64.replace(/-/g, "+").replace(/_/g, "/");
    // Add padding if needed
    while (base64.length % 4 !== 0) {
        base64 += "=";
    }

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Base64.parse(base64) },
        KEY,
        {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
}
const Ondutyapproval = (empId, appId) => {
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const mode = params.Mode;
    //   const { toggleSidebar, broken, rtl } = useProSidebar();
    const listViewData = useSelector((state) => state.listviewApi.rowData);
    const listViewColumn = useSelector((state) => state.listviewApi.columnData);
    const listViewurl = useSelector((state) => state.globalurl.listViewurl);
    const explorelistViewData = useSelector(
        (state) => state.exploreApi.explorerowData
    );
    const explorelistViewColumn = useSelector(
        (state) => state.exploreApi.explorecolumnData
    );
    const getLoading = useSelector((state) => state.formApi.getLoading);
    const data = useSelector((state) => state.formApi.Data);
    const isLoading = useSelector((state) => state.formApi.loading);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [show, setScreen] = React.useState("0");
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const Data = useSelector((state) => state.formApi.Data);
    const [openDEPopup, setOpenDEPopup] = useState(false);
    const [openADPopup, setOpenADPopup] = useState(false);
    const [openLETPopup, setOpenLETPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const EMPID = sessionStorage.getItem("EmpId");
    const compID = sessionStorage.getItem("companyId");
    const [showImage, setShowImage] = useState(params.Mode == "IM" ? true : false)
    var accessID = "TR242";
    const dispatch = useDispatch();
    var recID = decryptDataUrlSafe(params.id);
    const exploreLoading = useSelector((state) => state.exploreApi.loading);
    const [error, setError] = useState('');
    const rowSx = { height: 36, '& td, & th': { py: 0.5 } };
    const [files, setFiles] = useState([]);
    useEffect(() => {
        var url = store.getState().globalurl.empGetAttachmentUrl;

        axios
            .get(url, {
                params: {
                    empId,
                    appId
                }
            })
            .then((response) => {
                setFiles(response.data);
            })
            .catch((err) => {
                setError('Failed to fetch attachments.');
                console.error(err);
            })
            .finally(() => setLoading(false));

    }, [open, empId, appId]);
    const VISIBLE_FIELDS = ["SLNO", "Date", "NumberOfHours", "action"];
    const columns = React.useMemo(
        () =>
            explorelistViewColumn
                ? explorelistViewColumn.filter((column) =>
                    VISIBLE_FIELDS.includes(column.field)
                )
                : [],
        [explorelistViewColumn]
    );
    const [selectedLeavetypeOptions, setSelectedLeavetypeOptions] =
        useState(null);
    const [selectedLeavetypeid, setSelectedLeavetypeid] = useState(null);
    const [selectedLeavetypeName, setSelectedLeavetypeName] = useState(null);
    const validationSchema = Yup.object().shape({
        ProName: Yup.object()
            .nullable()
            .required("Project is required"),
    });
    const handleSelectionLeavetypename = (newValue) => {
        if (newValue) {
            //Leavetype
            setSelectedLeavetypeOptions(newValue);
            console.log(newValue, "--setSelectedLeavetypeOptions");
            setSelectedLeavetypeid(newValue.RecordID);

            //setSelectedLeavetypeid(newValue.LeavetypeRecordID);
            setSelectedLeavetypeName(newValue.Name);
        } else {
            setSelectedLeavetypeOptions(null);
            setSelectedLeavetypeid(null);
            setSelectedLeavetypeName(null);
        }
    };
    var userimg = store.getState().globalurl.imageUrl;
    if (mode === "A" || !data?.ImageName) {
        userimg = userimg + "Defaultimg.jpg";
    } else {
        userimg = userimg + data.ImageName;
    }

    function handleShow(type) {
        if (type == "LT") {
            setOpenLETPopup(true);
        }
    }

    // const [isPopupData, setisPopupdata] = React.useState(false);
    const [opendesignPopup, setOpendesignPopup] = useState(false);

    const fnLogOut = (props) => {
        Swal.fire({
            title: `Do you want ${props}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: props,
        }).then((result) => {
            if (result.isConfirmed) {
                if (props === "Logout") navigate("/");
                if (props === "Close") navigate(-1);
            }
        });
    };


    /*************************LOOKUP DATA*********************/
    const [openLTpopup, setOpenLTpopup] = useState(false);

    function handleShow(type) {
        if (type == "LT") {
            setOpenLTpopup(true);
        }
    }
    const [isPopupData, setisPopupdata] = React.useState(false);
    const [selectltLookupData, setselectLTLookupData] = React.useState({
        LTlookupID: "",
        LTlookupCode: "",
        LTlookupDesc: "",
    });

    if (isPopupData == false) {
        selectltLookupData.LTlookupID = Data.LeaveTypeID;
        selectltLookupData.LTlookupCode = Data.LeaveTypeCode;
        selectltLookupData.LTlookupDesc = Data.LeaveTypeName;
    }
    const childToParent = (childdata, type) => {
        console.log(childdata);

        if (type == "Leave Type") {
            setisPopupdata(true);
            setselectLTLookupData({
                LTlookupCode: childdata.Code,
                LTlookupID: childdata.RecordID,
                LTlookupDesc: childdata.Name,
            });
            setOpenLTpopup(false);
        }
    };

    //-------------------------------------LEAVE SAVE FUNCTION---------------------------------------------//

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const [day, month, year] = dateStr.split("-");
        return `${year}-${month}-${day}`; // Converts "08-02-2025" to "2025-02-08"
    };
    const currentDate = new Date().toISOString().split("T")[0];
    const ondutyInitialValue = {
        applieddate: mode == "A" ? currentDate : data.AppliedDate,
        RecordID: Data.RecordID,
        FromDate: Data.FromDate,
        ToDate: Data.ToDate,
        LeavePart: Data.LeavePart,
        Status: Data.Status,
        managerComments: Data.ManagerComments,
        comment: Data.Comments,
        ProName: Data.ProjectID
            ? { RecordID: Data.ProjectID, Code: Data.ProjectCode, Name: Data.ProjectName }
            : null,
        location: Data.Location,
        SortOrder: Data.SortOrder,
        Disable: Data.Disable,
    };

    console.log("Data:", Data);

    const ondutyFNsave = async (values, resetForm, del) => {
        setLoading(true);
        let action =
            mode === "A" && !del
                ? "insert"
                : mode === "E" && del
                    ? "harddelete"
                    : "update";
        // const idata = {
        //     RecordID: recID,
        //     EmployeeID: mode == "M" ? params.parentID : EMPID,
        //     FromDate: values.FromDate,
        //     ToDate: values.ToDate,
        //     LeavePart: values.LeavePart,
        //     Comments: values.comment,
        //     ProjectID: values.ProName?.RecordID || 0,
        //     ProjectName: values.ProName.Name || "",
        //     // ProjectID: values.ProName? values.ProName.RecordID : 0,
        //     Location: values.location,
        //     Status:
        //         mode == "A"
        //             ? "AL"
        //             : mode == "E" && values.Status == "QR"
        //                 ? "AL"
        //                 : values.Status,
        //     ManagerComments: values.managerComments,
        //     AppliedDate: values.applieddate,
        //     SortOrder: "1",
        //     Disable: "N",
        //     Source: "Self",

        //     //   LeaveTypeID: values.leavetype.RecordID || 0,
        // };
        const response = await dispatch(
            PermissionApprovalVerify({
                // action: "update",
                // DailyTaskRecordID: recID,
                // ApprovedBy: params.managerID,
                // Status: values.status,
                // PASSWORD: values.password,
                // ManagerComments: values.ManagerComments ? values.ManagerComments : "",
                RecordID: recID,
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Status: values.Status,
                Type: "OD",
                Password: values.password,
                ManagerComments: values.managerComments ? values.managerComments : ""
            })
        );
        if (response.payload.Status === "Y") {
            dispatch(mailNotify({
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Reason: "",
                RecordID: recID,
                Source: "M",
                Status: values.Status == "AP" ? "Y" : values.Status == "RJ" ? "N" : "Q",
                Type: "OD"
            })
            );
            toast.success(response.payload.Msg);
            navigate(`/approval/notification/OD/${values.Status}`);
        } else {
            console.log("🚀 ~ DTSaveFn ~ response.payload.Msg:", response.payload.Msg)
            toast.error(response.payload.Msg);
        }

    };

    useEffect(() => {
        dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
            var url = store.getState().globalurl.empGetAttachmentUrl;
            console.log(res, "response");
            axios
                .get(url, {
                    params: {
                        empId: data.EmployeeID,
                        appId: recID
                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));
        })
    }, []);
    async function fileUpload(file, EMPID, action, id, purpose) {
        console.log("🚀 ~ fileUpload ~ file:", file)
        const formData = new FormData();
        formData.append('file', file);
        formData.append('empId', Data.EmployeeID);
        formData.append('appId', Data.RecordID);
        formData.append('type', "OD");
        formData.append('source', "Self");
        formData.append("action", action);
        formData.append("id", id);
        formData.append("purpose", purpose);
        console.log("🚀 ~ fileUpload ~ formData:", formData)
        const respose = await dispatch(attachmentPost({ data: formData }))

        if (respose.payload.success) {
            toast.success(respose.payload.message)
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: data.EmployeeID,
                        appId: data.RecordID,

                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));
        } else {
            toast.success(respose.payload.message)
        }

        console.log("🚀 ~ fileUpload ~ respose:", respose)
    }
    return (
        <React.Fragment>
            {getLoading && <LinearProgress />}
            <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
                <Box display="flex" justifyContent="space-between" p={2}>
                    <Box display="flex" borderRadius="3px" alignItems="center">
                        {/* {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )} */}
                        <Typography variant="h5">On Duty</Typography>
                    </Box>
                    <Box display="flex">
                        <Tooltip title="Close">
                            <IconButton onClick={() => fnLogOut("Close")} color="error">
                                <ResetTvIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Logout">
                            <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                                <LogoutOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Paper>
            {!getLoading ? (
                //   <Box m="20px">
                <Paper elevation={3} sx={{ margin: "10px" }}>
                    {mode === "IM" && (
                        <Box
                            display="flex"
                            padding={1}
                            justifyContent="flex-end"
                            mt="2px"
                            gridColumn="span 4"
                            gap={2}
                            marginBottom={-5}
                        >
                            <IconButton
                                onClick={() => setShowImage(prev => !prev)}
                            >
                                <ArrowDownwardIcon sx={{ color: "blue" }} />
                            </IconButton>
                        </Box>)}

                    <Formik
                        initialValues={ondutyInitialValue}
                        enableReinitialize={true}
                        validationSchema={validationSchema}
                        onSubmit={(values, { resetForm }) => {
                            setTimeout(() => {
                                ondutyFNsave(values, resetForm, false);
                            }, 100);
                        }}
                    >
                        {({
                            errors,
                            touched,
                            handleBlur,
                            handleChange,
                            isSubmitting,
                            values,
                            handleSubmit,
                            resetForm,
                            setFieldValue,
                        }) => (
                            <form
                                onSubmit={handleSubmit}
                                onReset={() => {
                                    // selectCellRowData({ rowData: {}, mode: "A", field: "" });
                                    resetForm();
                                }}
                            >
                                <Box
                                    display="grid"
                                    //   gap="30px"
                                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                    gap={formGap}
                                    padding={1}
                                    sx={{
                                        "& > div": {
                                            gridColumn: isNonMobile ? undefined : "span 4",
                                        },
                                    }}
                                >
                                    <FormControl sx={{ gridColumn: "span 2", gap: "15px" }}>
                                        <TextField
                                            name="applieddate"
                                            type="date"
                                            id="applieddate"
                                            label="Applied Date"
                                            variant="standard"
                                            focused
                                            inputFormat="YYYY-MM-DD"
                                            value={values.applieddate}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            error={!!touched.applieddate && !!errors.applieddate}
                                            helperText={touched.applieddate && errors.applieddate}
                                            sx={{ gridColumn: "span 2" }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                max: new Date().toISOString().split("T")[0],
                                                readOnly: true,
                                            }}
                                        //   disabled={
                                        //     mode == "E" &&
                                        //     values.Status != "AL" &&
                                        //     values.Status != "RC"
                                        //   }
                                        />
                                        <FormControl
                                            focused
                                            variant="filled"
                                            sx={{ gridColumn: "span 2" }}
                                        //   disabled={
                                        //     mode == "E" &&
                                        //     values.Status != "AL" &&
                                        //     values.Status != "RC"
                                        //   }
                                        >
                                            <InputLabel variant="standard" id="LeavePart">
                                                {
                                                    <span>
                                                        Day Part <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-filled-label"
                                                fullWidth
                                                variant="standard"
                                                type="text"
                                                value={values.LeavePart}
                                                id="LeavePart"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="LeavePart"
                                                required
                                                inputProps={{ readOnly: true }}
                                                focused
                                            >
                                                <MenuItem value="FH">First Half</MenuItem>
                                                <MenuItem value="SH">Second Half</MenuItem>
                                                <MenuItem value="N">Full Day</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {!showImage ? <React.Fragment>
                                            <TextField
                                                // disabled={
                                                //   mode == "E" &&
                                                //   values.Status != "AL" &&
                                                //   values.Status != "RC"
                                                // }
                                                name="FromDate"
                                                type="date"
                                                id="FromDate"
                                                label="From Date"
                                                //inputFormat="YYYY-MM-DD"
                                                variant="standard"
                                                focused
                                                value={values.FromDate}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                required
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ readOnly: true }}

                                            />
                                            <TextField
                                                // disabled={
                                                //   mode == "E" &&
                                                //   values.Status != "AL" &&
                                                //   values.Status != "QR"
                                                // }
                                                name="ToDate"
                                                type="date"
                                                id="ToDate"
                                                label="To Date"
                                                //inputFormat="YYYY-MM-DD"
                                                variant="standard"
                                                focused
                                                value={values.ToDate}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                required
                                                sx={{ gridColumn: "span 2" }}
                                                inputProps={{
                                                    readOnly: true,
                                                    min:
                                                        values.FromDate ||
                                                        new Date().toISOString().split("T")[0],
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    gridColumn: "span 2",
                                                }}
                                            >
                                                <CheckinAutocomplete
                                                    //   disabled={
                                                    //     mode == "E" &&
                                                    //     values.Status != "AL" &&
                                                    //     values.Status != "QR"
                                                    //   }
                                                    disabled
                                                    name="ProName"
                                                    label={
                                                        <>
                                                            Project
                                                            <span style={{ color: "red" }}> * </span>
                                                        </>
                                                    }
                                                    id="ProName"
                                                    value={values.ProName}
                                                    onChange={(newValue) => {
                                                        setFieldValue("ProName", newValue);
                                                    }}
                                                    error={!!touched.ProName && !!errors.ProName}
                                                    helperText={touched.ProName && errors.ProName}
                                                    url={`${listViewurl}?data={"Query":{"AccessID":"2054","ScreenName":"Project","Filter":"parentID=${compID}","Any":""}}`}
                                                />
                                            </Box>
                                            {/* {touched.ProName && errors.ProName && (
                      <div style={{ color: "red", fontSize: "12px", marginTop: "-8px" }}>
                        {errors.ProName}
                      </div>
                    )} */}

                                            <TextField
                                                // disabled={
                                                //   mode == "E" &&
                                                //   values.Status != "AL" &&
                                                //   values.Status != "QR"
                                                // }
                                                name="location"
                                                type="text"
                                                id="location"
                                                label="Location"
                                                variant="standard"
                                                focused
                                                value={values.location}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                error={!!touched.location && !!errors.location}
                                                helperText={touched.location && errors.location}
                                                // required
                                                inputProps={{ readOnly: true }}
                                                sx={{ gridColumn: "span 2" }}

                                            />
                                            <TextField
                                                // disabled={
                                                //   mode == "E" &&
                                                //   values.Status != "AL" &&
                                                //   values.Status != "QR"
                                                // }
                                                name="comment"
                                                type="comment"
                                                id="comment"
                                                label="Work Details"
                                                multiline
                                                rows={6}
                                                variant="outlined"
                                                fullWidth
                                                focused
                                                required
                                                value={values.comment}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                error={!!touched.comment && !!errors.comment}
                                                helperText={touched.comment && errors.comment}
                                                sx={{ gridColumn: "span 2" }}
                                                inputProps={{ readOnly: true }}
                                            />

                                            {/* {mode == "M" ||
                        (mode == "E" &&
                          (values.Status == "RJ" || values.Status == "QR")) ? (
                        
                      ) : (
                        false
                      )} */}
                                            <TextField
                                                //   disabled={mode == "E" && values.Status != "AL"}
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Manager Comments"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.managerComments}
                                                id="managerComments"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="managerComments"
                                                sx={{
                                                    gridColumn: "span 2",
                                                }}
                                                focused
                                            />

                                            {/* {mode == "M" && ( */}
                                            <TextField
                                                select
                                                label="Status"
                                                id="Status"
                                                name="Status"
                                                value={values.Status}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                required
                                                focused
                                                variant="standard"
                                            >
                                                {/* <MenuItem value="AL">Applied</MenuItem> */}
                                                <MenuItem value="AP">
                                                    Approved
                                                </MenuItem>
                                                <MenuItem value="RJ">
                                                    Rejected
                                                </MenuItem>
                                                <MenuItem value="QR">Query</MenuItem>
                                            </TextField>
                                            {/* )} */}

                                            {/* {mode == "E" && values.Status == "AP" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                          Your Onduty Request Approved.
                        </Alert>
                      )}
                      {mode == "E" && values.Status == "RJ" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                          Your Onduty Request Rejected.
                        </Alert>
                      )}
                      {mode == "E" && values.Status == "QR" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                          Your Onduty request status Query.
                        </Alert>
                      )} */}
                                        </React.Fragment> : false}
                                    </FormControl>


                                </Box>
                                <Box
                                    display="flex"
                                    justifyContent="end"
                                    mt="20px"
                                    gap="20px"
                                    padding={1}
                                // flexDirection={isNonMobile ? "row" : "column"}
                                >
                                    {data.Status == "AP" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                                            Your Onduty request has been Approved.
                                        </Alert>
                                    )}

                                    {data.Status == "RJ" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                                           Your Onduty request has been Rejected.
                                        </Alert>
                                    )}
                                    {data.Status == "QR" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                                            Your Onduty request has been Queried.
                                        </Alert>
                                    )}
                                    <TextField
                                        required
                                        name="password"
                                        type="password"
                                        id="password"
                                        label="Password"
                                        variant="standard"
                                        focused
                                        value={values.password}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        fullWidth={isNonMobile ? false : true}
                                        // sx={{ gridColumn: "span 2", width: 300 }}
                                        inputProps={{ readOnly: data.Status == "AP" || data.Status == "RJ" ? true : false }}
                                    />
                                    <LoadingButton
                                        disabled={data.Status == "AP" || data.Status == "RJ"}
                                        color="success"
                                        variant="contained"
                                        type="submit"
                                        loading={isLoading}
                                    >
                                        Submit
                                    </LoadingButton>
                                </Box>
                            </form>
                        )}
                    </Formik>
                    {/* </Box> */}
                </Paper>
            ) : (
                false
                //      <Box display="flex" justifyContent="center" mt={4}>
                //    <Typography variant="h6" color="textSecondary">
                //      Loading data, please wait...
                //        </Typography>
                //  </Box>
            )}
            {mode === "IM" && files.length > 0 ? (
                <Box mt={2}
                >
                    <Paper elevation={3} sx={{ padding: 2 }}>
                        {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
                        <TableContainer component={Paper} >
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={rowSx}>
                                        <TableCell width={20}><strong>SL#</strong></TableCell>
                                        <TableCell ><strong>Uploaded Date</strong></TableCell>
                                        <TableCell><strong>Filename</strong></TableCell>
                                        <TableCell><strong>Purpose</strong></TableCell>
                                        <TableCell ><strong>Source</strong></TableCell>
                                        <TableCell><strong>View</strong></TableCell>


                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {files.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                No files uploaded yet.
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        files.map((file, index) => (
                                            <TableRow key={file.id || index} sx={rowSx}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{file.uploadedDate}</TableCell>
                                                <TableCell>{file.filename}</TableCell>
                                                <TableCell>{file.purpose}</TableCell>
                                                <TableCell>{file.source}</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Open File">
                                                        <IconButton
                                                            color="primary"
                                                            component="a"
                                                            href={file.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            size="small"
                                                        >
                                                            <OpenInNewIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="delete">
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => fileUpload(
                                                                "",
                                                                Data.EmployeeID,
                                                                "delete",
                                                                file.id,
                                                                file.purpose
                                                            )}
                                                            size="small"
                                                        >
                                                            <DeleteForeverIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>

                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>
            ) : null}
        </React.Fragment>
    );
};

export default Ondutyapproval;
